import Container from '../../atoms/container/playerLanguageModalIconContainer';
import Language from '../../atoms/icons/language';

function PlayerLanguageModalIcon() {
  return (
    <Container>
      <Language scale={1.4} />
    </Container>
  );
}

export default PlayerLanguageModalIcon;
